import { DialogContent, RedeemFormAlt } from "@/components";

export interface RedeemFormDialogAltProps {
    onClose?: () => void;
    initialRedeemAmount?: number;
    ableToSatisfy?: number;
}

export function RedeemFormDialogAlt({ initialRedeemAmount, ableToSatisfy }: RedeemFormDialogAltProps) {
    return (
        <DialogContent className="w-[860px] max-w-full">
            <RedeemFormAlt initialAmount={initialRedeemAmount} ableToSatisfy={ableToSatisfy} isDialog />
        </DialogContent>
    );
}
